<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes=" table-responsive">
            <template slot="header">
             <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title mb-0"><i class="icon-svg icon-building"></i>{{$t('listado_companias')}}</h4>
                <router-link to="contact" class="btn btn-add-outline btn-sm flex-shrink-0 ml-3">
                  <i class="icon-svg icon-plus"></i> {{$t("nuevo")}}
                </router-link>
             </div>
            </template>
            <l-table class="pl-4 table-hover table-striped"
                     :columns="table.columns"
                     :section="section"
                     :data="tableData"
                     @deleteEvent="onDeleteEvent">
            </l-table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { apiCallList, dataTableLengthMenu, dataTableEsLanguage, enhanceDataTableLength } from '../../mixins'

  const tableColumns = ['Id', 'name', 'Email', 'phone','document','actions']
  export default {
    mixins: [apiCallList],
    components: {
     
    },
    data () {
      return {
        table: {
          columns: [...tableColumns],
        },
        section : "contact",
        tableData : [],
        endpoint : "contacts",
      }
    },
    methods : {
        loadItems(){
            this.data.forEach((item) => {
              item.name = item.lastname ?  item.name + ' ' + item.lastname : item.name;
            });
            this.tableData = this.data;
            setTimeout(() => {
              window.$(".table").dataTable({
                pageLength: 10,
                lengthMenu: dataTableLengthMenu,
                language: dataTableEsLanguage,
                autoWidth: false,
                columnDefs: [{ orderable: false, targets: -1 }]
              });
              enhanceDataTableLength();
            },100);
        },
        onDeleteEvent(item){
          this.$dialog.confirm({
            title: this.$t("EliminarContacto"),
            body: this.$t("EliminarContactoText"),
            okText: this.$t("Eliminar"),
            cancelText: this.$t("Cancelar"),
          },
          { customClass: 'cd-dialog cd-dialog--danger' }).then(() => {
            this.$axios.delete("/contacts/" + item.id).then(() => {
              this.fetch();
            });
          });
        }
    }
  }
</script>
<style>

</style>
